import React, { useState, useEffect } from 'react'
import { commerce } from '../../utils/commerce'

import Hero from './Hero/Hero'
import Slide from '../Slides/Slide/Slide'
import Products from '../Products/Products'
import Title from '../PageTitles/Title'

import slideImgs from '../Slides/Slide/SlideImgs'
import commImgs from '../Slides/Slide/CommImgs'

function Home({addToCart}) {

  const [justDropped, setJustDropped] = useState([])
  const [airMax, setAirMax] = useState([])
  const [airForce, setAirForce] = useState([])

  const fetchJustDroppedProducts = async () => {
    const {data} = await commerce.products.list({
      category_slug: ['just-dropped'],
    })

    setJustDropped(data)
  }
  const fetchAirMax = async () => {
    const {data} = await commerce.products.list({
      category_slug: ['air-max'],
    })

    setAirMax(data)
  }
  const fetchForce = async () => {
    const {data} = await commerce.products.list({
      category_slug: ['air-force'],
    })

    setAirForce(data)
  }

  useEffect(() => {
    fetchJustDroppedProducts()
    fetchAirMax()
    fetchForce()
  }, [])
  
  return (
    <>
        <Hero />
        <Slide imgs={slideImgs} />
        <Title title="Just Dropped" id='first-title' />
        <Products products={justDropped} onAddToCart={addToCart} />
        <Title title="Air Max" id='second-title' />
        <Products products={airMax} onAddToCart={addToCart} />
        <Title title="Air Force" id='third-title' />
        <Products products={airForce} onAddToCart={addToCart} />
        <Title title="Culture" id='forth-title' />
        <Slide imgs={commImgs} />
    </>
  )
}

export default Home